import { useCallback } from 'react';
import { CircularProgress, InputAdornment, MenuItem, Stack, TextField } from '@mui/material';

import ValueLabel from '../models/ValueLabel';

interface DropdownQueryFormProps {
  loading?: boolean;
  relations?: Array<ValueLabel>;
  relationSelected?: ValueLabel;
  onChangeRelation?: (value: ValueLabel) => void;
  values?: Array<ValueLabel>;
  valueSelected?: ValueLabel;
  onChangeValue?: (value: ValueLabel) => void;
}

const DropdownQueryForm = (props: DropdownQueryFormProps) => {
  const {
    loading,
    relations = [],
    relationSelected,
    onChangeRelation,
    values = [],
    valueSelected,
    onChangeValue,
  } = props;

  const handleChangeRelation = useCallback(
    (e) => {
      const relation = relations.find((r) => r.value === e.target.value);
      if (relation) {
        onChangeRelation?.(relation);
        return;
      }
      onChangeRelation?.({ value: '', label: '' });
    },
    [relations, onChangeRelation]
  );

  const handleChangeValue = useCallback(
    (e) => {
      const value = values.find((r) => r.value === e.target.value);
      if (value) {
        onChangeValue?.(value);
        return;
      }
      onChangeValue?.({ value: '', label: '' });
    },
    [values, onChangeValue]
  );

  return (
    <Stack direction="column" gap={3} width={252}>
      <TextField
        id="search-filter-dropdown-query-form-relative-input"
        size="small"
        label="Relative"
        select
        value={relationSelected.value}
        onChange={handleChangeRelation}
        SelectProps={{
          MenuProps: {
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'left',
            },
            transformOrigin: {
              vertical: 'top',
              horizontal: 'left',
            },
          },
        }}
      >
        <MenuItem value="" style={{ display: 'none' }} />
        {relations.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </TextField>
      <TextField
        id="search-filter-dropdown-query-form-value-input"
        size="small"
        label="Value"
        select
        value={valueSelected.value}
        onChange={handleChangeValue}
        InputProps={{
          endAdornment: loading && (
            <InputAdornment position="end">
              <CircularProgress size="1em" />
            </InputAdornment>
          ),
        }}
        SelectProps={{
          MenuProps: {
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'left',
            },
            transformOrigin: {
              vertical: 'top',
              horizontal: 'left',
            },
          },
        }}
      >
        <MenuItem value="" style={{ display: 'none' }} />
        {values.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </TextField>
    </Stack>
  );
};

export { DropdownQueryFormProps };
export default DropdownQueryForm;
